<template>
    <div>
        <h1 class="h2 mb-4">Reset password</h1>
        <alert/>
        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
        >
            <div class="mb-1">
                <v-text-field
                outlined
                dense
                v-model="form.email"
                :rules="validate.email"
                label="E-mail"
                required
                />
            </div>
            <div class="text-right mb-3">
                    <router-link :to="{name: 'auth.login'}">{{$t('Go to login page')}}</router-link>
            </div>

            <div class="text-center">
                <v-btn
                color="primary"
                class="mr-4"
                @click="submit"
                >
                {{ $t('Submit') }}
                </v-btn>
            </div>
        </v-form>
    </div>
</template>

<script>
import validate from '@utils/validate'
import Alert from '@components/Alert'
import { call } from 'vuex-pathify'

export default {
  name: 'ForgotPasswordPage',
  components: { Alert },
  data: () => ({
    valid: true,
    form: {
      email: ''
    },
    validate: {
      email: [
        (v) => validate.required(v),
        (v) => validate.email(v)
      ]
    }
  }),
  methods: {
    ...call('alert', {
      hideAlert: 'hide'
    }),
    submit (e) {
      e.preventDefault()
      const valid = this.$refs.form.validate()
      if (valid) {
        this.hideAlert()
      }
    }
  }
}
</script>
